import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CursorGlow() {
    const [enabled, setEnabled] = useState(false);
    const x = useMotionValue(-600);
    const y = useMotionValue(-600);
    const sx = useSpring(x, { stiffness: 50, damping: 18 });
    const sy = useSpring(y, { stiffness: 50, damping: 18 });

    useEffect(() => {
        if (!window.matchMedia("(pointer: fine)").matches) return undefined;
        setEnabled(true);
        const fn = (e) => {
            x.set(e.clientX - 300);
            y.set(e.clientY - 300);
        };
        window.addEventListener("mousemove", fn, { passive: true });
        return () => window.removeEventListener("mousemove", fn);
    }, [x, y]);

    if (!enabled) return null;
    return (
        <motion.div
            aria-hidden
            data-testid="cursor-glow"
            className="pointer-events-none fixed left-0 top-0 z-[1] h-[600px] w-[600px] rounded-full"
            style={{
                x: sx,
                y: sy,
                background:
                    "radial-gradient(circle, rgba(201,162,39,0.07) 0%, rgba(201,162,39,0.03) 35%, transparent 70%)",
            }}
        />
    );
}
